import { render } from "./FileMultiUpload.vue?vue&type=template&id=1526e273&scoped=true"
import script from "./FileMultiUpload.vue?vue&type=script&lang=js"
export * from "./FileMultiUpload.vue?vue&type=script&lang=js"

import "./FileMultiUpload.vue?vue&type=style&index=0&id=1526e273&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1526e273"]])

export default __exports__